<ul *ngIf="draggable" (drop)="dropMe($event)" class="list-container ngx-dnd-container" ngxDroppable="droppable" [model]="viewList">
  <li *ngFor="let viewItem of viewList" class="list-item ngx-dnd-item" [model]="viewItem" ngxDraggable>
    <ng-container *ngTemplateOutlet="content; context: {viewItem: viewItem}"></ng-container>
  </li>
</ul>

<ul *ngIf="!draggable" class="list-container">
  <li *ngFor="let viewItem of viewList" class="list-item">
    <ng-container *ngTemplateOutlet="content; context: {viewItem: viewItem}"></ng-container>
  </li>
</ul>

<ng-template #content let-viewItem="viewItem">
  <!-- if got child -->
  <ng-container *ngIf="viewItem.ChildCount > 0; else noChild">
    <input type="checkbox" id="{{ 'cb-' + viewItem.ViewID }}">
    <label for="{{ 'cb-' + viewItem.ViewID }}" (click)="getViewChild(viewItem.ViewID)"></label>
    <div class="view-parent" (click)="selectView(viewItem.ViewID)">
      <span class="view-item" [ngClass]="{'active': selectedView == viewItem.ViewID, 'hide': currentView != view.currentView}" >
        {{ viewItem.ViewName }}
      </span>
      <span [ngClass]="{'utter-icon': true, 'menuOpen': currentItem == viewItem.ViewID}" (click)="onContextMenu($event, viewItem)"><i class="fa fa-ellipsis-v"></i></span>
    </div>
    <div class="clearfix"></div>
    <app-treeview class="child-container" [viewList]="childView" [componentId]="componentId" [currentView]="currentView" [draggable]="draggable" (viewSelected)="viewSelectedChanged($event)"></app-treeview>
  </ng-container>

  <!-- if got no child -->

  <ng-template #noChild>
    <div class="view-parent" (click)="selectView(viewItem.ViewID)">
      <span [ngClass]="{'view-item': true, 'active': selectedView == viewItem.ViewID, 'hide': currentView != view.currentView}">
        {{ viewItem.ViewName }}
      </span>
      <span [ngClass]="{'utter-icon': true, 'menuOpen': currentItem == viewItem.ViewID}" (click)="onContextMenu($event, viewItem)"><i class="fa fa-ellipsis-v"></i></span>
    </div>
    <div class="clearfix"></div>
  </ng-template>
</ng-template>

<context-menu [useBootstrap4]="true" (close)="onCloseContextMenu()">
  <!-- <ng-template contextMenuItem>
    Edit View
  </ng-template> -->
  <ng-template contextMenuItem (execute)="pullPopup($event.item)">
    Add Quick Phrase
  </ng-template>
</context-menu>